const useStyles = {
  width: '100%',
  height: '2000px',
};

export { useStyles };
